import { api } from '@/lib/api-client'
import { RecurringFrequency } from '@/types/skyward-types'
import { serialize } from 'object-to-formdata'

export type SkywardRecurringFoodPaymentLegacy = {
  amount: number
  feeAmount: number
  frequency: RecurringFrequency
  id: number
  nextDate: string
  student: string
  studentId: string
  threshold: number
}
// Food Alert API
export type AddSkywardLowBalancePropsLegacy = {
  amount: number
  nameId: string
  orgId: number
  firstName: string
  lastName: string
}
export type SkywardFoodAlertPayloadLegacy = {
  amount: number // format: double
  skywardId: string
  schoolId: number // format: int32
  id?: number // format: int32
  first: string
  last: string
}

export const getSkywardRecurringFoodPaymentsLegacy = async (
  history: boolean = false,
  payments: boolean = true,
  showFailed: boolean = false,
): Promise<SkywardRecurringFoodPaymentLegacy[]> => {
  try {
    const resp = await api.get<SkywardRecurringFoodPaymentLegacy[]>(
      `/api/RecurringFood?history=${history}&payments=${payments}&showFailed=${showFailed}`,
    )
    if (resp.status !== 200) {
      throw new Error(resp.statusText, { cause: resp })
    }
    return resp.json()
  } catch (error) {
    console.error('Error fetching Skyward recurring food payments:', error)
    throw new Error(`Failed to fetch Skyward recurring food payments`, { cause: error })
  }
}

export const cancelSkywardRecurringFoodPaymentLegacy = async (id: number): Promise<boolean> => {
  try {
    const response = await api.delete(`/api/RecurringFood?id=${id}`)
    if (response.status !== 200) {
      throw new Error(response.statusText, { cause: response })
    }
    return true
  } catch (error) {
    console.error('Error canceling Skyward recurring food payment:', error)
    throw new Error(`Failed to cancel Skyward recurring food payment`, { cause: error })
  }
}

export const getSkywardLowBalanceAlertLegacy = async (): Promise<SkywardFoodAlertPayloadLegacy[]> => {
  try {
    const res = await api.get<SkywardFoodAlertPayloadLegacy[]>('/api/SkywardFoodAlert')
    if (res.status !== 200) {
      throw new Error(res.statusText)
    }
    return res.json()
  } catch (error) {
    console.error('Error fetching Skyward low balance alerts:', error)
    throw new Error('Failed to fetch Skyward low balance alerts', { cause: error })
  }
}
export const createSkywardLowBalanceAlertLegacy = async (params: AddSkywardLowBalancePropsLegacy): Promise<boolean> => {
  try {
    const data: SkywardFoodAlertPayloadLegacy = {
      amount: params.amount,
      skywardId: params.nameId,
      schoolId: params.orgId,
      first: params.firstName,
      last: params.lastName,
    }
    const formData = serialize(data, {})
    const res = await api.post('api/SkywardFoodAlert', { body: formData })
    if (res.status !== 200) {
      throw new Error(res.statusText)
    }
    return true
  } catch (error) {
    console.error('Error adding Skyward low balance alert:', error)
    throw new Error('Failed to add Skyward low balance alert', { cause: error })
  }
}
export const cancelSkywardLowBalanceAlertLegacy = async (id: number): Promise<boolean> => {
  try {
    const response = await api.delete(`/api/SkywardFoodAlert/${id}`)
    if (response.status !== 200) {
      throw new Error(response.statusText)
    }
    return true
  } catch (error) {
    console.error('Error canceling Skyward food alert:', error)
    throw new Error('Failed to cancel Skyward food alert', { cause: error })
  }
}
